import { GalleryGrid } from "./GalleryGrid";
import { Lightbox } from "./Lightbox";
import { SortToolbar } from "./SortToolbar";
import { SelectModeBar } from "./SelectModeBar";
import { MemoriesRow } from "./MemoriesRow";
import { AlbumHeroHeader } from "./AlbumHeroHeader";
import { ReelButton } from "../reel/ReelButton";

// Top-level gallery orchestrator. AlbumHeroHeader.tsx now owns every header/
// toolbar control (favorites filter, view mode, refresh, select-mode
// trigger, search, back/title) as real React state - the old getVanillaEl
// wiring to static .gallery-header/.gallery-search buttons (favoritesFilterBtn/
// viewModeGrid/viewModeList/refreshBtn/gallerySearchInput) is gone along
// with those static elements themselves (index.html).
export function GalleryScreen() {
  return (
    <>
      <AlbumHeroHeader />
      <ReelButton />
      <GalleryGrid />
      <Lightbox />
      <SortToolbar />
      <SelectModeBar />
      <MemoriesRow />
    </>
  );
}
